export default {
  filter: 'Filtrar',
  resize: 'Redimensionar',
  expand: 'Ampliar',
  duplicate: 'Duplicar',
  remove: 'Remover',
  averageTime: 'Tempo médio',
  atTime: 'às',
  weekOf: 'Semana de',
};
